<template>
  <b-row>
    <b-col md="12"
           lg="12"
           sm="12"
    >
      <div class="contenedor">
        <b-card class="contenedor">
          <div slot="header"
               class="font-weight-bold text-center"
               style="font-size: 16px"
          >
            Medidas
          </div>

          <b-row>
            <b-col class="text-center">
              <el-checkbox v-model="VisualEmpresa.regla"
                           label="Regla"
                           border
              />
            </b-col>
            <b-col class="text-center">
              <el-checkbox v-model="VisualEmpresa.fecha_fab"
                           label="Fabricante-FechaFDS"
                           border
              />
            </b-col>
          </b-row>

          <table class="table table-hover table-striped"
                 style="font-size:9pt;"
          >
            <thead>
            <tr class="table-active">
              <th>Medida</th>
              <th style="width:80px;"
                  class="text-center"
              >
                Frases H
              </th>
              <th style="width:80px;"
                  class="text-center"
              >
                Frases P
              </th>
              <th style="width:70px;"
                  class="text-center"
              >
                ET
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>ET Pequeña (Aprox 5x6cm - 5x7cm) (Baker 7x5cm)</td>
              <td>
                <b-form-select class="form-control"
                               v-model="Medidas.medidah4x6"
                               :options="Medidas.medidah"
                />
              </td>
              <td>
                <b-form-select class="form-control"
                               v-model="Medidas.medidap4x6"
                               :options="Medidas.medidap"
                />
              </td>
              <td class="text-center text-danger">
                <i @click="generarEtiquetas('E')"
                   class="fa fa-file-pdf-o fa-3x pdf-boton"
                />
              </td>
            </tr>
            <tr>
              <td>ET Mediana (Aprox 7x10cm - 7x12cm)</td>
              <td class="text-center">
                <b-form-select class="form-control"
                               v-model="Medidas.medidah7x10"
                               :options="Medidas.medidah"
                />
              </td>
              <td class="text-center">
                <b-form-select class="form-control"
                               v-model="Medidas.medidap7x10"
                               :options="Medidas.medidap"
                />
              </td>
              <td class="text-center text-danger">
                <i @click="generarEtiquetas('F')"
                   class="fa fa-file-pdf-o fa-3x pdf-boton"
                />
              </td>
            </tr>
            <tr>
              <td>ET Grande (Aprox 18x12cm)</td>
              <td class="text-center">
                <b-form-select class="form-control"
                               v-model="Medidas.medidah18x10"
                               :options="Medidas.medidah"
                />
              </td>
              <td class="text-center">
                <b-form-select class="form-control"
                               v-model="Medidas.medidap18x10"
                               :options="Medidas.medidap"
                />
              </td>
              <td class="text-center text-danger">
                <i @click="generarEtiquetas('G')"
                   class="fa fa-file-pdf-o fa-3x pdf-boton"
                />
              </td>
            </tr>
            <tr>
              <td>ET Extra-Grande (Aprox 22x18cm) (Baker 29x21cm)
              </td>
              <td class="text-center">
                <b-form-select class="form-control"
                               v-model="Medidas.medidah21x18"
                               :options="Medidas.medidah"
                />
              </td>
              <td class="text-center">
                <b-form-select class="form-control"
                               v-model="Medidas.medidap21x18"
                               :options="Medidas.medidap"
                />
              </td>
              <td class="text-center text-danger">
                <i @click="generarEtiquetas('H')"
                   class="fa fa-file-pdf-o fa-3x pdf-boton"
                />
              </td>
            </tr>
            </tbody>
          </table>
        </b-card>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';

import loader from './../../../../containers/loader';

export default {
  name: 'Medidas-et-sga',
  props: ['admin', 'idEmpresa'],
  data() {
    return {
      loading: false
    };
  },
  components: {
    loader
  },
  computed: {
    ...mapState('sga', ['Medidas', 'idiomas', 'versiones', 'idioma']),
    ...mapState('etiquetas', [
      'pdfet',
      'VisualEmpresa',
      'dirEtiqueta'
    ]),
    ...mapState('sga', [
      'filtro'
    ]),
  },
  methods: {
    ...mapActions('etiquetas', [
      'generarEtiquetaPDF'
    ]),
    ...mapMutations('etiquetas', ['cargarData',]),
    async generarEtiquetas(tipo, cantidad = 0) {

      let pdfet = {};

      if (this.filtro.empresa != '') {
        pdfet.empresa = this.filtro.empresa;
      } else {
        pdfet.empresa = this.idEmpresa;
      }

      pdfet.idioma = this.VisualEmpresa.idioma;
      pdfet.version = 6;
      pdfet.regla = this.VisualEmpresa.regla;
      pdfet.fabfecha = this.VisualEmpresa.fecha_fab;
      pdfet.rol = 1;
      pdfet.tipoproducto = 'producto';
      pdfet.cabecera = this.VisualEmpresa.cabecera;
      pdfet.tipoEtiqueta = tipo;
      pdfet.cantidad = cantidad;

      this.loading = true;
      this.cargarData(pdfet);

      await this.generarEtiquetaPDF();
      window.open(this.dirEtiqueta);
      this.loading = false;
    },
  }
};
</script>
<style>
.pdf-boton:hover {
  cursor: pointer;
  animation-name: pdf;
}
</style>
